import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { RemoveServiceStateData } from './types';

const initialState: RemoveServiceStateData = {
	data: {
		data: { message: '', error: '' },
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchRemoveService = createAsyncThunk(
	'api/fetchRemoveService',
	({ sessionId, uslugaId }: { sessionId: string; uslugaId: string }) => api.fetchRemoveService(sessionId, uslugaId),
);

const removeServiceSlice = createSlice({
	name: 'removeService',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchRemoveService.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchRemoveService.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchRemoveService.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default removeServiceSlice.reducer;
